import { CustomerContactForm, CustomersRepository } from "@/repositories/client.repository";

export async function getClientById(id: string) {
  return CustomersRepository.getById(id);
}

export async function getPropertiesByClientId(clientId: string) {
  return CustomersRepository.getVendorPropertiesForClient(clientId);
}

export async function updateContact(id: string, contact: CustomerContactForm) {
  return CustomersRepository.updateContact(id, contact);
}
